import React, { useState } from 'react';
import axiosInstance from '../utils/axiosConfig';
import { makeStyles } from '@material-ui/core/styles';
import { 
    Card, 
    TextField, 
    Typography, 
    Grid, 
    CircularProgress, 
    Snackbar 
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '../Input/Button';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    backgroundColor: '#f8f8f8',
    borderRadius: '12px',
    },
    title: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
    },
    formControl: {
    width: '100%',
    marginBottom: theme.spacing(2),
    },
    inputField: {
    marginBottom: theme.spacing(2),
    backgroundColor: '#ffffff',
    },
    buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    },
    loadingSpinner: {
    marginLeft: theme.spacing(1),
    }
}));

export default function MentorLifeTopicUpload({ theme, showNotification, onSuccess }) {
    const classes = useStyles();
    const [formData, setFormData] = useState({
    name: '',
    url: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [open, setOpen] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
        ...prev,
        [name]: value
        }));
    };
    
    const validateYoutubeUrl = (url) => {
        console.log("🚀 ~ validateYoutubeUrl ~ url:", url);
        // Simple validation for YouTube URLs
        const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
        return youtubeRegex.test(url);
    };

    const handleSubmit = async (e) => {
        console.log("🚀 ~ handleSubmit ~ e:", e);
        e.preventDefault();
        
        // Validate fields
        if (!formData.name.trim()) {
            setError('Topic name is required');
            setOpen(true);
            return;
        }
        
        if (!formData.url.trim()) {
            setError('URL is required');
            setOpen(true);
            return;
        }
        
        if (!validateYoutubeUrl(formData.url)) {
            setError('Please enter a valid YouTube URL');
            setOpen(true);
            return;
        }
        
        setLoading(true);
        
        try {
            const response = await axiosInstance.post(
                `/life_topics/add`, 
                formData
            );
            
            if (response.status === 200 || response.status === 201) {
                // Reset form
                setFormData({ name: '', url: '' });
                
                // Show success notification
                if (showNotification) {
                    showNotification('Life topic successfully added!', 'success');
                }
                
                // Call success callback if provided
                if (onSuccess && typeof onSuccess === 'function') {
                    onSuccess(response.data);
                }
            }
        } catch (error) {
            console.error('Error adding life topic:', error);
            
            const errorMessage = error.response?.data?.message || 
                                'Failed to add life topic. Please try again.';
            
            setError(errorMessage);
            setOpen(true);
        } finally {
            setLoading(false);
        }
    };
    
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }
        setOpen(false);
    };
    
    return (
        <Card className={classes.root}>
        <Typography variant="h5" className={classes.title}>
            Add New Life Topic Video
        </Typography>
        
        <form onSubmit={(e) => {
                console.log("Form submission event triggered");
                handleSubmit(e);
            }}>
            <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                className={classes.inputField}
                label="Topic Name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                placeholder="Enter topic name"
                />
            </Grid>
            
            <Grid item xs={12}>
                <TextField
                className={classes.inputField}
                label="YouTube URL"
                name="url"
                value={formData.url}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                placeholder="https://www.youtube.com/watch?v=..."
                helperText="Enter a valid YouTube video URL"
                />
            </Grid>
            
            <Grid item xs={12} className={classes.buttonContainer}>
            <Button
                theme={theme}
                type="submit"
                disabled={loading}
                onClick={(e) => {
                    console.log("Button clicked");
                    if (e.type !== 'submit') {
                    // If this wasn't a submit event, call handleSubmit directly
                    handleSubmit(e);
                    }
                }}
                >
                {loading ? (
                    <>
                    Submitting
                    <CircularProgress size={24} className={classes.loadingSpinner} />
                    </>
                ) : (
                    'Add Life Topic'
                )}
                </Button>
            </Grid>
            </Grid>
        </form>
        
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity="error">
            {error}
            </Alert>
        </Snackbar>
        </Card>
    );
}